import { Provider } from 'react-redux'
import { store, persistor } from '@/store/store'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from 'sonner'
import Layout from '@/components/layout/Layout'
import loadable from '@/utils/loadable'
import Loader from '@/components/ui/loader'
import { PersistGate } from 'redux-persist/integration/react'
import ConfigureApiClient from '@/hooks/useConfigureApiClient'
import AnalysisDetails from './pages/analysis_history/AnalysisDetails.tsx'
import TransactionList from './pages/transaction/Transactions.tsx'
import version from './../package.json'
import SubscriptionAddEdit from './pages/subscription/SubscriptionAddEdit.tsx'

const AuthLayout = loadable(() => import('@/components/layout/AuthLayout'), <Loader />)
const Dashboard = loadable(() => import('@/pages/Dashboard'), <Loader />)
const NotFound = loadable(() => import('@/pages/404Page'), <Loader />)
const EditProfilePage = loadable(() => import('@/pages/EditProfilePage'), <Loader />)
const ChangePasswordPage = loadable(() => import('@/pages/ChangePasswordPage'), <Loader />)

const UserTable = loadable(() => import('@/pages/user/ListUser'), <Loader />)
const UserProfileDetails = loadable(() => import('@/pages/user/UserProfileDetails.tsx'), <Loader />)
const AnalysisHistoryTable = loadable(() => import('@/pages/analysis_history/AnalysisHistory.tsx'), <Loader />)
const SubscriptionTable = loadable(() => import('@/pages/subscription/SubscriptionList.tsx'), <Loader />)
const Settings = loadable(() => import('@/pages/settings/SettingsPage.tsx'), <Loader />)
const SelfExclusionList = loadable(() => import('@/pages/self_exclusion/SelfExclusion.tsx'), <Loader />)

export default function App() {
    return (
        <>
            <Toaster position="top-right" richColors />
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <ConfigureApiClient />
                    <Router>
                        <AppRoutes />
                    </Router>
                </PersistGate>
            </Provider>
        </>
    )
}

function AppRoutes() {

    return (
        <>
            <div className="fixed bottom-2 right-3 z-1111111 ">v {version.version}</div>
            <Routes>
                <Route path="/login" element={<AuthLayout activeForm="login" />} />
                <Route path="/forgot-password" element={<AuthLayout activeForm="forgot" />} />
                <Route path="/reset-password" element={<AuthLayout activeForm="reset" />} />
                <Route path="/" element={<Layout />}>
                    <Route index element={<Dashboard />} />
                    <Route path="/edit-profile" element={<EditProfilePage />} />
                    <Route path="/change-password" element={<ChangePasswordPage />} />
                    <Route path='/transactions' element={<TransactionList />}></Route>
                    <Route path='/settings' element={<Settings />}></Route>
                    <Route path='/self-exclusion' element={<SelfExclusionList />}></Route>

                    {/* User Management */}
                    <Route path="user">
                        <Route index element={<UserTable />} />
                        <Route path=":id" element={<UserProfileDetails />}>
                        </Route>
                        <Route path=":id/:screenshotId" element={<AnalysisDetails />} />
                    </Route>

                    {/* Analysis Management */}
                    <Route path="analysis-history">
                        <Route index element={<AnalysisHistoryTable />} />
                        <Route path=":screenshotId" element={<AnalysisDetails />} />
                    </Route>

                    {/* Analysis Management */}
                    <Route path="subscription">
                        <Route index element={<SubscriptionTable />} />
                        <Route path="add" element={<SubscriptionAddEdit />} />
                        <Route path="update/:id" element={<SubscriptionAddEdit />} />
                        {/* <Route path=":screenshotId" element={<AnalysisDetails />} /> */}
                    </Route>


                </Route>
                <Route path="*" element={<NotFound />} />
            </Routes>
        </>
    )
}
